var _path, _path2, _path3, _circle, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSurveyMarketing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 96,
    viewBox: "0 0 120 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.9998 6H24.9998C23.8952 6 22.9998 6.89543 22.9998 8V87C22.9998 88.1046 23.8952 89 24.9998 89H92.9998C94.1043 89 94.9998 88.1046 94.9998 87V8C94.9998 6.89543 94.1043 6 92.9998 6Z",
    fill: "#E4E1FF",
    stroke: "#1B1B1B",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7685 48.0781H32.9998V78H38.7685V48.0781ZM50.2148 56.3209H44.4461V77.9842H50.2148V56.3209ZM73.1078 48H67.3388V77.9481H73.1078V48ZM84.5545 56.321H78.7857V77.9277H84.5545V56.321Z",
    fill: "#8372FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62 35.6232H66L59 27L52 35.6232H56V78H62V35.6232Z",
    fill: "#8372FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 88.0002,
    cy: 30,
    r: 18,
    fill: "white",
    stroke: "#1B1B1B",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105.081 24.3215C103.889 20.7353 101.598 17.6154 98.5337 15.4039C95.4692 13.1924 91.7864 12.0015 88.0072 12L88.0002 30L105.081 24.3215Z",
    fill: "#FFBB00",
    stroke: "#1B1B1B",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyMarketing);
export default __webpack_public_path__ + "static/media/survey-marketing.7fbd2f54.svg";
export { ForwardRef as ReactComponent };